<template>
  <div>
  
    <loading-indicator
      v-if="isLoading"
    />

    <p v-if="message !== null">
      {{message}}
    </p>

    <ul v-if="offerIds !== null && offerIds.length > 0">
      <li
        v-for="offerId in offerIds"
        :key="offerId"
      >
        <router-link
          :to="{name: 'player_offer_old', params: {playerId: playerId, offerId: offerId}}"
        >
          Offer {{offerId}}
        </router-link>
      </li>
    </ul>

  </div>
</template>

<script>
import { HTTP } from '../http-common';
import notifier from '../notifier';
import LoadingIndicator from './LoadingIndicator.vue';

export default {
  name: 'PlayerOffersOld',

  components: {
    LoadingIndicator,
  },

  props: {
    playerId: {
      type: Number,
      required: true,
    }
  },

  data() {
    return {
      isLoading: false,
      offerIds: null,
    };
  },

  computed: {
    message() {
      if(this.offerIds !== null && this.offerIds.length === 0) {
        return 'No offers.';
      }
      return null;
    },
  },

  created() {
    this.isLoading = true;

    const url = `/player/${this.playerId}/offer_ids`;
    HTTP.get(url)
    .then(response => {
      const data = response.data.data;
      if(data === null) {
        notifier.showError('Invalid server response. data === null.', {sender: this});
        return;
      }

      this.offerIds = data;
    })
    .catch(e => {
      notifier.showError(e.response.data);
    })
    .finally(() => {
      this.isLoading = false;
    });
  },

};
</script>
